module.exports = __webpack_public_path__ + "img/2025-08-16b_3.7fda84a6.jpg";